import React from 'react';
import { motion } from 'framer-motion';
import { Scroll, Wind } from 'lucide-react';
export function TCMHero() {
  return <div className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-10" data-id="element-21">
      {/* Background Texture */}
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none" data-id="element-22">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#C8102E]/5 rounded-full blur-3xl" data-id="element-23" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#00A86B]/5 rounded-full blur-3xl" data-id="element-24" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="mb-6 inline-flex items-center gap-2 text-[#C8102E] font-medium tracking-[0.2em] uppercase text-sm border-b border-[#C8102E]/30 pb-1" data-id="element-26">
          <Scroll size={16} data-id="element-27" />
          <span data-id="element-28">AIIMR Presents</span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-[#1a1a1a] mb-8 leading-tight tracking-tight" data-id="element-29">
          Advanced Online <br data-id="element-30" />
          <span className="text-[#C8102E]" data-id="element-31">TCM Diagnostic</span> <br data-id="element-32" />
          <span className="italic font-light text-4xl md:text-6xl text-[#1a1a1a]/60" data-id="element-33">
            Mastercourse
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-[#1a1a1a]/80 mb-12 font-serif text-lg" data-id="element-34">
          <div className="flex items-center gap-2" data-id="element-35">
            <span className="w-2 h-2 rounded-full bg-[#C8102E]" data-id="element-36" />
            <span data-id="element-37">Tongue Diagnosis (Giovanni Maciocia)</span>
          </div>
          <div className="hidden md:block w-px h-8 bg-[#1a1a1a]/20" data-id="element-38" />
          <div className="flex items-center gap-2" data-id="element-39">
            <span className="w-2 h-2 rounded-full bg-[#00A86B]" data-id="element-40" />
            <span data-id="element-41">Pulse Diagnosis (Dr. Jimmy Chang)</span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="max-w-2xl mx-auto text-lg md:text-xl text-[#1a1a1a]/70 leading-relaxed mb-12 font-serif" data-id="element-42">
          Dive deep into classical diagnostic arts where tongue and pulse reveal
          the body's Qi dynamics, organ balance, and hidden patterns.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-43">
          <a href="#details" className="px-8 py-4 bg-[#C8102E] text-[#F5F1E8] font-medium tracking-widest uppercase hover:bg-[#A00C24] transition-colors duration-300 shadow-lg shadow-[#C8102E]/20" data-id="element-44">
            View Course Details
          </a>
          <a href="#contact" className="px-8 py-4 border border-[#1a1a1a]/20 text-[#1a1a1a] font-medium tracking-widest uppercase hover:bg-[#1a1a1a]/5 transition-colors duration-300" data-id="element-45">
            Register Now
          </a>
        </motion.div>
      </div>

      {/* Decorative vertical text */}
      <div className="absolute left-4 md:left-12 top-1/2 transform -translate-y-1/2 hidden lg:block writing-vertical-rl text-[#1a1a1a]/10 text-6xl font-serif select-none" data-id="element-46">
        望聞問切
      </div>

      <div className="absolute right-4 md:right-12 top-1/2 transform -translate-y-1/2 hidden lg:block writing-vertical-rl text-[#1a1a1a]/10 text-6xl font-serif select-none" data-id="element-47">
        陰陽五行
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2 text-[#1a1a1a]/40" data-id="element-48">
        <span className="text-xs uppercase tracking-widest" data-id="element-49">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-[#1a1a1a]/40 to-transparent" data-id="element-50" />
      </motion.div>
    </div>;
}